/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProjectPhaseFragmentDoc } from '../ProjectPhasesConfigurator.generated.js';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../attachments/Attachments.generated.js';
import { PhoneFragmentDoc, CrmContactPersonFragmentDoc } from '../../../auth/UserDataProvider.generated.js';
import { ProjectContactLinksFragmentDoc, QuoteItemContactLinksFragmentDoc } from '../boxes/ProjectOverviewContactsBox.generated.js';
export type ProjectListItemFragment = { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName>, title: string, deadline?: any | null, overdue: boolean, state: Types.ProjectStateMachineStatus, number: string, createdAt?: any | null, categories: Array<string>, type: Types.ProjectType, leadId?: number | null, urgent: boolean, earliestStart?: any | null, earliestPlanSessionDate?: any | null, planned: boolean, phase: { __typename: 'OrganisationProjectPhase', id: string, name: string, applicableForState: Types.ProjectStateMachineStatus, color: string }, budget?: { __typename: 'Money', currency: string, amount: number } | null, plannedUsers: Array<{ __typename: 'User', id: string, firstname: string, familyname: string } | null>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } } | null, buildingInfo?: { __typename: 'BuildingInfo', id: string, buildingAddress?: { __typename: 'Address', streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null } | null, crmLinks: Array<{ __typename: 'ProjectLinkCrmOrganisation', id: string, linkAs: string, crmOrganisation: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } } | { __typename: 'ProjectLinkCrmUser', id: string, linkAs: string, crmUser: { __typename: 'CrmPerson', id: string, fullname: string, firstname: string, familyname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, crmCompany: { __typename: 'CrmCompany', id: string } } }> };

export const ProjectListItemFragmentDoc = gql`
    fragment ProjectListItem on Project {
  id
  viewerPermissions
  title
  deadline
  overdue
  state
  number
  createdAt
  categories
  type
  phase {
    id
    ...ProjectPhase
  }
  leadId
  budget {
    currency
    amount
  }
  urgent
  plannedUsers {
    id
    firstname
    familyname
  }
  assignee {
    id
    user {
      id
      firstname
      familyname
      fullname
      avatar {
        ...AttachmentSnapshot
      }
    }
  }
  viewerPermissions
  buildingInfo {
    id
    buildingAddress {
      streetLines1
      city
      postalCode
      countryCode
      location {
        lat
        lng
      }
    }
  }
  crmOrganisation {
    id
    title
    email
    phones {
      id
      ...Phone
    }
    contactPerson {
      id
      ...CrmContactPerson
    }
  }
  crmLinks {
    ...ProjectContactLinks
  }
  earliestStart
  earliestPlanSessionDate
  planned
}
    ${ProjectPhaseFragmentDoc}
${AttachmentSnapshotFragmentDoc}
${PhoneFragmentDoc}
${CrmContactPersonFragmentDoc}
${ProjectContactLinksFragmentDoc}`;